import { render, staticRenderFns } from "./kioskDemoView.vue?vue&type=template&id=164af2f2&scoped=true"
import script from "./kioskDemoView.vue?vue&type=script&lang=js"
export * from "./kioskDemoView.vue?vue&type=script&lang=js"
import style0 from "./kioskDemoView.vue?vue&type=style&index=0&id=164af2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164af2f2",
  null
  
)

export default component.exports